import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
let CustomTimeLine = class CustomTimeLine extends Vue {
    constructor() {
        super(...arguments);
        this.snackbar = new CBcSnackbar();
        this.customHistory = [];
    }
    get showItems() {
        if (!this.filterInfo.length) {
            return this.customHistory;
        }
        return this.customHistory.filter((it) => this.filterInfo.includes(it.department));
    }
    getCustomShowText(it, orderInfo) {
        const showName = it.stepText || it.stepName || '';
        const time = it.time || '';
        const charge = it.charge || '';
        const creator = it.creator || '';
        const lastData = it.lastData || '';
        const currentData = it.currentData || '';
        const remark = it.remark || '';
        switch (true) {
            case (/创建/i.test(showName)):
                {
                    return `<div style="color: black">创建：</span><span style="color: rgba(42, 130, 228, 1)">${creator}</div>
        <span>负责人:</span><span style="color: rgba(42, 130, 228, 1)">${charge}&nbsp;</span>
        <span style="color: black">备注:</span><span style="color: rgba(42, 130, 228, 1)">${remark}</span>`;
                }
                break;
            case (/变更|解绑/i.test(showName)):
                {
                    let last = lastData;
                    let current = currentData;
                    if (/设备/i.test(showName)) {
                        if (last) {
                            last = JSON.parse(last).map((v) => v.deviceId).join(',');
                        }
                        if (current) {
                            current = JSON.parse(current).map((v) => v.deviceId).join(',');
                        }
                    }
                    return `<div style="color: black">当前负责人</span><span style="color: rgba(42, 130, 228, 1)">${charge}</div>
        <div style="color: black">变更负责人:&nbsp;</span><span style="color: rgba(42, 130, 228, 1)">${creator}</div>
        <span>变更记录:</span><span v-if="last">${last}</span><span v-if="last">&nbsp;->&nbsp;</span>
        <span style="color: rgba(42, 130, 228, 1)">${current}&nbsp;</span>`;
                }
                break;
            case (/派遣/i.test(showName)):
                {
                    return `<div style="color: black">人员:&nbsp;</span><span style="color: rgba(42, 130, 228, 1)">${currentData}</div>`;
                }
                break;
            case (/汇款|结算/i.test(showName)):
                {
                    return `<div style="color: black">负责人</span><span style="color: rgba(42, 130, 228, 1)">${charge}</div>
        <div style="color: black">创建人员:&nbsp;</span><span style="color: rgba(42, 130, 228, 1)">${creator}</div>
        <span>付款进度:</span><span v-if="last">${lastData}</span><span v-if="last">&nbsp;->&nbsp;</span>
        <span style="color: rgba(42, 130, 228, 1)">${currentData}&nbsp;</span>`;
                }
                break;
            default:
                {
                    return `<div style="color: black">创建人员：</span><span style="color: rgba(42, 130, 228, 1)">${creator}</div>
        <span>负责人:</span><span style="color: rgba(42, 130, 228, 1)">${charge}&nbsp;</span>
        <span style="color: black">备注:</span><span style="color: rgba(42, 130, 228, 1)">${remark}</span>`;
                }
                break;
        }
    }
    async getOrderHistory() {
        if (this.customInfo && this.customInfo.customerName) {
            this.customHistory = [];
            await this.axios.get('/api/project/order/history', { params: { equalName: this.customInfo.customerName } })
                .then((res) => {
                const result = res.data && res.data.result || [];
                this.customHistory = result;
            })
                .catch((err) => this.snackbar.error('获取客户历史信息失败!'));
        }
    }
    async mounted() {
        // console.log('item mounted: ', JSON.stringify(this.customInfo))
        await this.getOrderHistory();
    }
    async created() {
    }
};
__decorate([
    Prop({ default: () => [] })
], CustomTimeLine.prototype, "filterInfo", void 0);
__decorate([
    Prop({ default: () => [] })
], CustomTimeLine.prototype, "customInfo", void 0);
CustomTimeLine = __decorate([
    Component({
        name: 'CoustomerTimeline',
        components: {
            BcSnackbar,
        },
    })
], CustomTimeLine);
export default CustomTimeLine;
